<template>
    <generic-dropdown :wide="true">
        <template slot="title">
            <slot />
        </template>

        <label
            v-if="financial"
            :for="id"
            class="cms-content-our-range-filter__input-label cms-content-our-range-filter__input-label--range"
        >
            <span>{{ minFormatted }}</span>
            <span>{{ maxFormatted }}</span>
        </label>
        <label
            v-else
            :for="id"
            class="cms-content-our-range-filter__input-label cms-content-our-range-filter__input-label--range"
        >
            <span>{{ min }}</span>
            <span>{{ max }}</span>
        </label>
        <div
            class="cms-content-our-range-filter__input-min-max-range"
            :id="id"
            ref="input"
        ></div>
        <span class="cms-content-our-range-filter__current" v-if="financial"
            >{{ minSelectedFormatted }} - {{ maxSelectedFormatted }}</span
        >
        <span class="cms-content-our-range-filter__current" v-else
            >{{ minSelectedFormatted }} - {{ maxSelectedFormatted }} miles</span
        >
    </generic-dropdown>
</template>

<script>
import GenericDropdown from "./GenericDropdown.vue";
import { customEvent } from "../../../modules/tracking/AnalyticsEvents";
import NumberFormat from "../../../used-vue/api/NumberFormat";
import noUiSlider from "nouislider";
import "nouislider/distribute/nouislider.css";

export default {
    props: {
        minKey: String,
        maxKey: String,
        step: Number,
        financial: Boolean,
        id: String,
        event: {
            type: Object,
            default: null,
        }
    },
    components: {
        GenericDropdown,
    },
    data() {
        return {
            firstLoad: true,
            firstInteraction: false,
            slider: null,
        };
    },
    methods: {
        priceFormat(value) {
            return `£${NumberFormat(value)}`;
        },
    },
    computed: {
        min() {
            return this.$store.state.initialFilters[this.minKey] ?? null;
        },
        minSelected() {
            return this.$store.state.sliderFilters[this.minKey] ?? null;
        },
        minFormatted() {
            if (this.financial) {
                return `£${NumberFormat(this.min)}`;
            }
            return NumberFormat(this.min);
        },
        minSelectedFormatted() {
            if (this.financial) {
                return `£${NumberFormat(this.minSelected)}`;
            }
            return NumberFormat(this.minSelected);
        },
        max() {
            return this.$store.state.initialFilters[this.maxKey] ?? null;
        },
        maxSelected() {
            return this.$store.state.sliderFilters[this.maxKey] ?? null;
        },
        maxFormatted() {
            if (this.financial) {
                return `£${NumberFormat(this.max)}`;
            }
            return NumberFormat(this.max);
        },
        maxSelectedFormatted() {
            if (this.financial) {
                return `£${NumberFormat(this.maxSelected)}`;
            }
            return NumberFormat(this.maxSelected);
        },
    },
    mounted() {
        this.$nextTick(function () {
            this.slider = noUiSlider.create(this.$refs.input, {
                start: [this.min, this.max],
                connect: true,
                step: this.step,
                behaviour: 'tap',
                range: {
                    min: this.min,
                    max: this.max,
                },
                // keep values as integers instead of converting to strings with 2 decimal places
                format: {
                    to: (value) => Math.round(value),
                    from: (value) => Math.round(value),
                },
            });

            this.slider.on("update", (values) => {
                // Prevent triggering another API call when slider first initializes
                if (this.firstLoad || (values[0] == this.minSelected && values[1] == this.maxSelected)) {
                    this.firstLoad = false;
                    this.$store.dispatch("updateSliderFilters", {
                        [this.minKey]: values[0],
                        [this.maxKey]: values[1],
                    });
                    return;
                }
                if (!this.firstInteraction) {
                    this.firstInteraction = true;
                    const { category, label } = this.event;
                    customEvent(category, label, "Interacted");
                }
                this.$store.dispatch("updateSliderFilters", {
                    [this.minKey]: values[0],
                    [this.maxKey]: values[1],
                });
            });
        });
    },
};
</script>
